import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './qrCode.module.scss';
import useWindowSize from 'utils/useWindowSize';
import clsx from 'clsx';
import { ReactComponent as DownloadIcon } from '../../../../../../assets/svg/icons/scarica.svg';
import { ReactComponent as Zlogo } from '../../../../../../assets/svg/zb-logo.svg';
import AvatarIcon from 'Containers/Common/AvatarIcon';
import html2canvas from 'html2canvas';
import LinearLoader from 'Containers/Common/LinearLoader';

const QRcodeImg = ({ activeSalon, closeModal }) => {
  const salonUsername = activeSalon?.username || activeSalon?.name || 'qr-code';
  const salonLink = `https://application.zetabarber.it/barber/${salonUsername}`;
  const qrImg = `https://api.qrserver.com/v1/create-qr-code/?size=95x95&data=${encodeURIComponent(salonLink)}`;
  const { isMobile } = useWindowSize();
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  const generateShare = async () => {
    try {
      const elementToCapture = document.querySelector('#qrCode');
      if (!elementToCapture) {
        setIsLoading(false);
        return;
      }

      const canvas = await html2canvas(elementToCapture, {
        allowTaint: true,
        useCORS: true,
        backgroundColor: null,
        scale: 2,
      });

      canvas.toBlob((blob) => {
        if (!blob) {
          setIsLoading(false);
          return;
        }

        const href = URL.createObjectURL(blob);
        const anchorElement = document.createElement('a');
        anchorElement.href = href;
        anchorElement.download = `${salonUsername}.png`;

        document.body.appendChild(anchorElement);
        anchorElement.click();
        document.body.removeChild(anchorElement);
        window.URL.revokeObjectURL(href);

        setIsLoading(false);
        closeModal?.();
      }, 'image/png');
    } catch (error) {
      console.error('QR download failed', error);
      setIsLoading(false);
    }
  };

  return (
    <div className={clsx(styles.container, { [styles.container_mbl]: isMobile })}>
      <section className={styles.body}>
        <div id={'qrCode'} className={styles.card}>
          <header className={styles.head} style={{ flexDirection: 'column' }}>
            <div
              style={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <AvatarIcon
                icon={activeSalon?.icon}
                size={'90px'}
                style={{ position: 'absolute' }}
              />
            </div>
          </header>
          <div className={styles.center}>
            <div className={styles.qr_container}>
              <div className={styles.border} />
              <img src={qrImg} alt="QR Code" crossOrigin="anonymous" />
            </div>
            <Zlogo className={styles.logo} width={'100px'} />
          </div>
          <div className={styles.foot}>
            <h1 className={styles.big_text}>{t('settings.sharingContainer.qrCode.scanAndBook')}</h1>
          </div>
        </div>
      </section>
      <section className={styles.footer}>
        {isLoading ? <LinearLoader /> : null}
        <button
          type="button"
          onClick={() => {
            setIsLoading(true);
            generateShare();
          }}
          disabled={isLoading}
          className={clsx(styles.action_btn, { [styles.disable]: isLoading })}
        >
          {t('settings.sharingContainer.qrCode.download')}{' '}
          <DownloadIcon width={'24px'} height={'24px'} className={styles.icon} />
        </button>
      </section>
    </div>
  );
};

export default QRcodeImg;
